import React from "react";
import { Box, Flex, Text } from "@chakra-ui/react";
import { capitalize } from "lodash-es";
import { TOOTH_STATE_TO_COLOR } from "../../duck";

const Legend: React.FC = () => {
  return (
    <Flex m={4} mt={6} columnGap={8} justifyContent="center">
      {Object.entries(TOOTH_STATE_TO_COLOR).map(([tooth, color]) => (
        <Flex key={tooth} columnGap={2}>
          <Box w={6} h={6} background={color} borderRadius="md" />
          <Text>{capitalize(tooth)}</Text>
        </Flex>
      ))}
    </Flex>
  );
};

export default Legend;
